import { Modal, ModalBody } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FaTrash } from "react-icons/fa";
import { PrimaryButton } from "components/Button/style";
import { formatarDinheiro } from "_utils/Money";
import { useMaskInput } from "hooks/useMaskInput";
import { useState } from "react";
import { ICustoEmLote, IProcessoEmLote } from "../../../../interface/IProcessoEmLote";
import { ModalCertezaRemoverCusto } from "../ModalCertezaRemoverCusto";
import { ModalSucessoRemoverCusto } from "../ModalSucessoRemoverCusto";
import {
  BotaoRemover,
  CustoNome,
  InputTabela,
  TabelaContainer,
  TabelaHeader,
  TabelaLinha,
} from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  processo: IProcessoEmLote;
  onSalvar: (processo: IProcessoEmLote) => void;
  onRemoverCusto: (idDescricao: number) => void;
}

export function ModalEditarCustos({ show, handleClose, processo, onSalvar, onRemoverCusto }: IProps) {
  const { mInputValorBR } = useMaskInput();
  const [custos, setCustos] = useState<ICustoEmLote[]>([...processo.custos]);
  const [showModalRemoverCusto, setShowModalRemoverCusto] = useState(false);
  const [showModalSucesso, setShowModalSucesso] = useState(false);
  const [indexRemover, setIndexRemover] = useState<number | null>(null);

  const onChangeValor = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = mInputValorBR(e);
    setCustos((prev) => prev.map((c, i) => (i === index ? { ...c, valor: raw } : c)));
  };

  const onChangeObs = (index: number, value: string) => {
    setCustos((prev) => prev.map((c, i) => (i === index ? { ...c, observacao: value } : c)));
  };

  const onClickRemover = (index: number) => {
    setIndexRemover(index);
    setShowModalRemoverCusto(true);
  };

  const onConfirmRemover = () => {
    if (indexRemover === null) return;
    const custoRemovido = custos[indexRemover];
    setCustos((prev) => prev.filter((_, i) => i !== indexRemover));
    onRemoverCusto(custoRemovido.idDescricao);
    setShowModalRemoverCusto(false);
    setIndexRemover(null);
    setShowModalSucesso(true);
  };

  const onFecharSucesso = () => {
    setShowModalSucesso(false);
    if (custos.length === 0) handleClose();
  };

  const onSalvarClick = () => {
    onSalvar({ ...processo, custos });
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="lg" backdrop="static" keyboard={false}>
        <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 20px" }}>
          <Modal.Title style={{ fontSize: "1rem", fontWeight: "bold" }}>
            Editar custos — Processo {processo.idProcesso}
          </Modal.Title>
          <span style={{ cursor: "pointer" }} onClick={handleClose}>
            <FontAwesomeIcon icon={faXmark} />
          </span>
        </Modal.Header>
        <ModalBody style={{ padding: "16px 20px" }}>
          <TabelaContainer>
            <TabelaHeader>
              <span>Custo</span>
              <span>Valor</span>
              <span>Observação</span>
              <span>Ações</span>
            </TabelaHeader>
            {custos.map((custo, i) => (
              <TabelaLinha key={i}>
                <CustoNome>{custo.label}</CustoNome>
                <InputTabela
                  value={
                    custo.valor != null && custo.valor !== ""
                      ? formatarDinheiro(Number(custo.valor))
                      : ""
                  }
                  onChange={(e) => onChangeValor(i, e)}
                  placeholder="R$ 0,00"
                />
                <InputTabela
                  value={custo.observacao}
                  onChange={(e) => onChangeObs(i, e.target.value)}
                  placeholder="Observação"
                />
                <BotaoRemover onClick={() => onClickRemover(i)} title="Remover custo">
                  <FaTrash />
                </BotaoRemover>
              </TabelaLinha>
            ))}
          </TabelaContainer>

          <div className="d-flex justify-content-end gap-3 mt-4">
            <PrimaryButton outline variante="primary" style={{ width: "9rem" }} onClick={handleClose}>
              Cancelar
            </PrimaryButton>
            <PrimaryButton style={{ width: "9rem" }} onClick={onSalvarClick} disabled={!custos.length}>
              Salvar
            </PrimaryButton>
          </div>
        </ModalBody>
      </Modal>

      <ModalCertezaRemoverCusto
        show={showModalRemoverCusto}
        handleClose={() => {
          setShowModalRemoverCusto(false);
          setIndexRemover(null);
        }}
        onConfirm={onConfirmRemover}
      />

      <ModalSucessoRemoverCusto show={showModalSucesso} handleClose={onFecharSucesso} />
    </>
  );
}
